import React from 'react';

// Colour ramp per RPE bucket — gives the runner a visual sense of effort
// without reading the number. 1-2 green, 3-4 light, 5-6 amber, 7-8 orange,
// 9-10 red. Matches Borg-style RPE.
function bucketColor(rpe) {
  if (rpe <= 2) return { bar: 'bg-accent', text: 'text-text-body' };
  if (rpe <= 4) return { bar: 'bg-accent', text: 'text-text-body' };
  if (rpe <= 6) return { bar: 'bg-accent', text: 'text-text-body' };
  if (rpe <= 8) return { bar: 'bg-accent', text: 'text-text-body' };
  return { bar: 'bg-accent', text: 'text-text-body' };
}

// `size` matches ZoneBadge:
//   - 'lg': 10 little squares with the number on the right
//   - 'sm': just the number + dot for compact mode
export default function RpeBar({ rpe, size = 'lg' }) {
  if (rpe == null) return null;
  const safe = Math.max(1, Math.min(10, Math.round(rpe)));
  const { bar, text } = bucketColor(safe);

  if (size === 'sm') {
    return (
      <span className={`inline-flex items-center gap-1 text-[10px] font-bold ${text}`}>
        <span className={`inline-block w-2 h-2 rounded-full ${bar}`} />
        RPE {safe}/10
      </span>
    );
  }

  return (
    <div className="flex items-center gap-2" title={`Rate of Perceived Exertion: ${safe}/10`}>
      <span className={`text-xs font-bold ${text} shrink-0`}>RPE {safe}/10</span>
      <div className="flex gap-0.5">
        {Array.from({ length: 10 }, (_, i) => (
          <div
            key={i}
            className={`w-2 h-3 rounded-sm ${i < safe ? bar : 'bg-pressed'}`}
          />
        ))}
      </div>
    </div>
  );
}
